import React, { Component } from "react";
// import PropTypes from "prop-types";
import { connect } from "react-redux";
import withAuth from "../../../components/withAuth";
import {
  Row,
  Header,
  Col,
  HeaderPage,
  Modal,
  Button,
  ButtonGroup,
  Alerts,
  Input,
  Dropdown,
  Checkbox,
  P,
  CodeEditor,
  VirtualDiv,
  Label
} from "../../../ui";

// STATE AND STORE
// LIBS
import API from "../../../api";
import MarkersTableView from "../../../components/markers/tableView";
import Model from "../../../models/markers";
import validateForm from "../../../lib/helpers/validateForm";
import TinyMCE from "../../../components/tinymce";

class SettingsMarker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      markers: [],
      form: {
        text_description: {
          value: "",
          isEdited: false,
          isError: false,
          errors: [],
          validate: Model.text_description
        },
        text_name: {
          value: "",
          isEdited: false,
          isError: false,
          errors: [],
          validate: Model.text_name
        },
        field_data: {
          value: "",
          isEdited: false,
          isError: false,
          errors: [],
          validate: Model.field_data
        },
        is_block: {
          value: false,
          isEdited: false,
          isError: false,
          isBoolean: true,
          errors: [],
          validate: Model.is_block
        },
        is_block_array: {
          value: false,
          isEdited: false,
          isError: false,
          isBoolean: true,
          errors: [],
          validate: Model.is_block_array
        },
        content_block: {
          value: "",
          isEdited: false,
          isError: false,
          errors: [],
          validate: Model.content_block
        },
        format: {
          value: "",
          isEdited: false,
          isError: false,
          errors: [],
          validate: Model.format
        },
        code: {
          value: "",
          isEdited: false,
          isError: false,
          errors: [],
          validate: Model.code
        }
      },
      modalMarkerAction: "create",
      selectedItemId: "",
      saveDisabled: false,
      modalMarkerShow: false
    };
  }

  async componentDidMount() {
    await this.loadingMarkers();
  }

  loadingMarkers = async () => {
    this.setState({
      loading: true
    });

    let markers = [];

    try {
      let markersResult = await API.settings.marker.getList();

      markers = markersResult || [];
    } catch (err) {
      console.log(err);
    }

    this.setState({
      markers,
      loading: false
    });
  };

  handleChangeForm = (name, value) => {
    const { form } = this.state;

    if (name && form[name]) {
      if (form[name].isNumber) {
        value = String(value) || "";
      }

      this.setState(prevState => {
        return {
          form: {
            ...prevState.form,
            [name]: {
              ...prevState.form[name],
              value,
              isEdited: true,
              isError: false,
              errors: []
            }
          }
        };
      });
    }
  };

  handleInput = e => {
    let value = e.target.value;
    let name = e.target.name;

    this.handleChangeForm(name, value);
  };

  handleCheckbox = (name, e) => {
    let value = String(e.target.checked) === "true";

    this.handleChangeForm(name, value);
  };

  handleSelectDropdown(item, name) {
    if (item && name) {
      let value = item.id;

      this.handleChangeForm(name, value);
    }
  }

  handleEditorChange = (e, name) => {
    let value = e.target.getContent();

    this.handleChangeForm(name, value);
  };

  handleDeleteSubmit = async e => {
    try {
      let resultDeleted = await API.settings.marker.deleteOne(
        this.state.selectedItemId
      );

      if (resultDeleted) {
        Alerts.success("Маркер удалён");

        // Включаем кнопку, данные сохранились
        this.setState({
          saveDisabled: false,
          loading: false
        });

        this.handleModalShowCancel();

        await this.loadingMarkers();
      } else {
        Alerts.error("Маркер не удалён");

        // Включаем кнопку, данные не сохранились
        this.setState({
          saveDisabled: false,
          loading: false
        });
      }
    } catch (err) {
      console.log(err);

      // Включаем кнопку, данные не сохранились
      this.setState({ saveDisabled: false, loading: false });
    }
  };

  handleFormSubmit = async e => {
    if (this.state.modalMarkerAction === "delete") {
      this.handleDeleteSubmit(e);
      return;
    }

    if (e) {
      e.preventDefault();
    }

    const result = validateForm(this.state.form);

    this.setState({
      form: result.form
    });

    // Success
    if (result.valid) {
      // Отключаем кнопку
      this.setState({ saveDisabled: true, loading: true });

      const { form } = this.state;
      const optionsRequest = {};

      // Только те которыйе изменили
      if (this.state.modalMarkerAction === "edit") {
        for (let nameItem in form) {
          if (form[nameItem].isEdited) {
            optionsRequest[nameItem] = form[nameItem].value;
          }
        }
      } else {
        // все поля
        for (let nameItem in form) {
          if (form[nameItem].isBoolean) {
            optionsRequest[nameItem] = String(form[nameItem].value) === "true";
          } else {
            optionsRequest[nameItem] = form[nameItem].value;
          }
        }
      }

      // Есть изменения?
      if (
        (this.state.modalMarkerAction === "edit" &&
          Object.keys(optionsRequest).length > 0) ||
        (this.state.modalMarkerAction === "create" &&
          Object.keys(optionsRequest).length === Object.keys(form).length)
      ) {
        let resultOperation;

        if (this.state.modalMarkerAction === "edit") {
          // Изменение одного
          await API.settings.marker.editOne(this.state.selectedItemId, {
            ...optionsRequest
          });

          resultOperation = true;
        } else {
          // Создание нового
          resultOperation = await API.settings.marker.createOne({
            ...optionsRequest
          });
        }

        if (resultOperation) {
          Alerts.success(
            `${
              this.state.modalMarkerAction === "edit"
                ? "Изменён"
                : "Создан новый"
            } маркер`
          );

          // Включаем кнопку, данные сохранились
          this.setState({
            saveDisabled: false,
            loading: false
          });

          this.handleModalShowCancel();

          await this.loadingMarkers();
        } else {
          Alerts.error(
            `Маркер не ${
              this.state.modalMarkerAction === "edit" ? "изменён" : "создан"
            }`
          );

          // Включаем кнопку, данные не сохранились
          this.setState({
            saveDisabled: false,
            loading: false
          });
        }
      } else {
        Alerts.alert("Заполните нужные поля");

        // Включаем кнопку, данные не сохранились
        this.setState({ saveDisabled: false, loading: false });
      }
    }
  };

  /**
   * Открытие мобального окна
   */
  handleModalShow = isShow => {
    this.setState({
      modalMarkerShow: isShow
    });
  };

  handleModalOpen = (e, actionName, itemId) => {
    if (e) {
      e.preventDefault();
    }

    let { form, markers } = this.state;

    if (actionName === "edit" || actionName === "delete") {
      for (let m of markers) {
        if (m._id === itemId) {
          form.text_name.value = m.text_name;
          form.text_description.value = m.text_description;
          form.code.value = m.code;
          form.content_block.value = m.content_block;
          form.field_data.value = m.field_data;
          form.format.value = m.format;
          form.is_block.value = m.is_block;
          form.is_block_array.value = m.is_block_array;

          break;
        }
      }
    }

    this.setState({
      form,
      modalMarkerAction: actionName,
      selectedItemId: itemId,
      modalMarkerShow: true
    });
  };

  /**
   * Отмена мобального окна
   */
  handleModalShowCancel = () => {
    if (this.state.loading) {
      return;
    }

    let { form } = this.state;

    for (let k in form) {
      if (k.isBoolean) {
        form[k].value = false;
      } else {
        form[k].value = "";
      }

      form[k].isEdited = false;
      form[k].isError = false;
      form[k].errors = [];
    }

    this.setState({
      form,
      modalMarkerAction: "create",
      selectedItemId: "",
      modalMarkerShow: false
    });
  };

  render() {
    return (
      <div>
        <HeaderPage title="Маркеры" back={this.props.history.goBack}>
          <ButtonGroup>
            <Button
              type="submit"
              theme="success"
              onClick={() => this.handleModalShow(true)}
            >
              Создать
            </Button>
          </ButtonGroup>
        </HeaderPage>

        <Modal
          width="sm"
          title={
            this.state.modalMarkerAction === "delete"
              ? "Удалить маркер"
              : "Создать маркер"
          }
          show={this.state.modalMarkerShow}
          yesTitle={
            this.state.modalMarkerAction === "delete" ? "Удалить" : "Сохранить"
          }
          yesHandlerOnClick={e =>
            this.state.saveDisabled ? function() {} : this.handleFormSubmit(e)
          }
          yesDisabled={this.state.saveDisabled}
          noHandlerOnClick={() =>
            this.state.saveDisabled
              ? function() {}
              : this.handleModalShowCancel()
          }
          noCloseOnClickOutside={this.state.saveDisabled}
        >
          {this.state.modalMarkerAction === "delete" ? (
            <P>Вы действительно хотите удалить маркер?</P>
          ) : (
            <div>
              <Input
                label="Название:"
                name="text_name"
                value={this.state.form.text_name.value}
                handleChange={this.handleInput}
                errors={this.state.form.text_name.errors}
                disabled={this.state.saveDisabled}
              />
              <Input
                label="Описание:"
                name="text_description"
                value={this.state.form.text_description.value}
                handleChange={this.handleInput}
                errors={this.state.form.text_description.errors}
                disabled={this.state.saveDisabled}
              />
              <Input
                label="Источник данных:"
                name="field_data"
                value={this.state.form.field_data.value}
                handleChange={this.handleInput}
                errors={this.state.form.field_data.errors}
                disabled={this.state.saveDisabled}
              />

              {!this.state.form.is_block.value ? (
                <Dropdown
                  type="select"
                  block={true}
                  top={true}
                  label="Формат:"
                  title="Выберите формат"
                  list={[
                    {
                      title: "Не выбрано",
                      clear: true
                    },
                    {
                      type: "hr"
                    },
                    {
                      id: "sumFormat",
                      title: "Формат суммы",
                      onSelect: true,
                      select: true
                    },
                    {
                      id: "getDayLabelNumber",
                      title: "Добавление надписи - день/дня/дней",
                      onSelect: true,
                      select: true
                    },
                    {
                      id: "moment-DD.MM.YYYY",
                      title: "Вывод даты - DD.MM.YYYY",
                      onSelect: true,
                      select: true
                    },
                    {
                      id: "moment-HH:mm",
                      title: "Вывод времени - moment-HH:mm",
                      onSelect: true,
                      select: true
                    },
                    {
                      id: "getBiletOperationString",
                      title:
                        "Вывод операции по билету - Создание/Продление/Выкуп/Списание",
                      onSelect: true,
                      select: true
                    },
                    {
                      id: "sumTextRu",
                      title: "Число прописью - на русском",
                      onSelect: true,
                      select: true
                    },
                    {
                      id: "sumTextKz",
                      title: "Число прописью - на казахском",
                      onSelect: true,
                      select: true
                    }
                  ]}
                  selectedId={this.state.form.format.value}
                  onSelect={item => {
                    this.handleSelectDropdown(item, "format");
                  }}
                  errors={this.state.form.format.errors}
                  disabled={this.state.saveDisabled}
                />
              ) : null}

              <br />
              <Checkbox
                label="Это блок:"
                name="is_block"
                checked={this.state.form.is_block.value}
                handleChange={e => this.handleCheckbox("is_block", e)}
                disabled={this.state.saveDisabled}
              />

              {this.state.form.is_block.value ? (
                <VirtualDiv>
                  <Checkbox
                    label="Это массив блоков:"
                    name="is_block_array"
                    checked={this.state.form.is_block_array.value}
                    handleChange={e => this.handleCheckbox("is_block_array", e)}
                    disabled={this.state.saveDisabled}
                  />

                  <Label>Контент:</Label>
                  <TinyMCE
                    loading={this.state.loading}
                    saving={this.state.saveDisabled}
                    value={this.state.form.content_block.value}
                    onChange={e => this.handleEditorChange(e, "content_block")}
                    disabled={this.state.saveDisabled}
                    height={300}
                  />
                  <Input
                    label="Контент:"
                    name="content_block"
                    value={this.state.form.content_block.value}
                    handleChange={this.handleInput}
                    errors={this.state.form.content_block.errors}
                    disabled={this.state.saveDisabled}
                  />
                </VirtualDiv>
              ) : null}
              <CodeEditor
                name="code"
                label="Код:"
                value={this.state.form.code.value}
                handleChange={code => this.handleChangeForm("code", code)}
              />
            </div>
          )}
        </Modal>

        <Row>
          <Col>
            <Header size={4}>Залоговые билеты</Header>

            <MarkersTableView
              showButtons={true}
              data={this.state.markers}
              loading={this.state.loading}
              handleModalOpen={this.handleModalOpen}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  myUser: state.user
});

export default withAuth(connect(mapStateToProps)(SettingsMarker));
